/**
 * Boards ↔ project scope, pure (cards 3.1 / 3.2). A board is in a project by
 * the project's `contains board:<id>` link; nothing is stamped on the board.
 */

export const boardNodeId = (board) => `board:${board.id}`;

/** The board's own scope on the wire: a team board is its team's, else personal. */
export const boardWireScope = (board) => (board.visibility === 'team' && board.teamId != null ? `team:${board.teamId}` : 'personal');

const teamOfProject = (project) => {
  const key = String(project?.scopeKey || '');
  return key.startsWith('team:') ? key.slice('team:'.length) : null;
};

/** Projects a board may join: personal projects for a private board, its own team's for a team board. */
export function projectsForBoard(board, projects = []) {
  const team = board.visibility === 'team' && board.teamId != null ? String(board.teamId) : null;
  return projects.filter((p) => (team ? teamOfProject(p) === team : teamOfProject(p) == null));
}

/** Ids of the projects whose links contain `node`. */
export function projectIdsContaining(node, links = []) {
  const ids = new Set();
  for (const l of links || []) if (l && l.rel === 'contains' && String(l.to) === node) ids.add(String(l.from).replace(/^project:/, ''));
  return ids;
}

/** A team project's team when the user can create boards there (the dialog's default), else null. */
export function boardTeamForProject(project, shareableTeams = []) {
  const team = teamOfProject(project);
  if (team == null) return null;
  return (shareableTeams || []).some((t) => String(t.id) === team) ? team : null;
}
